const VALIDATABLE_CONTROL_SELECTORS = ['input', 'select', 'textarea'];
const VALIDATABLE_CONTROL_SELECTOR = VALIDATABLE_CONTROL_SELECTORS.join(', ');
const REQUIRED_CONTROL_SELECTOR = [
    ...VALIDATABLE_CONTROL_SELECTORS.map((selector) => `${selector}[required]`),
    ...VALIDATABLE_CONTROL_SELECTORS.map((selector) => `${selector}[data-mf-required="true"]`),
].join(', ');

export const isVisibleForValidation = (element) => {
    if (!element) {
        return false;
    }

    let current = element;
    while (current && current.nodeType === Node.ELEMENT_NODE) {
        if (current.hidden || current.getAttribute('aria-hidden') === 'true') {
            return false;
        }

        const style = window.getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden') {
            return false;
        }

        current = current.parentElement;
    }

    return true;
};

export const syncRequiredStateForVisibleControls = (root) => {
    if (!root) {
        return;
    }

    root.querySelectorAll(REQUIRED_CONTROL_SELECTOR).forEach((control) => {
        if (control.required) {
            control.dataset.mfRequired = 'true';
        }

        if (control.dataset.mfRequired !== 'true') {
            return;
        }

        control.required = isVisibleForValidation(control);
    });
};

export const reportVisibleValidity = (root) => {
    if (!root) {
        return true;
    }

    syncRequiredStateForVisibleControls(root);

    const firstInvalidControl = Array.from(root.querySelectorAll(VALIDATABLE_CONTROL_SELECTOR))
        .filter((control) => isVisibleForValidation(control))
        .find((control) => typeof control.checkValidity === 'function' && !control.checkValidity());

    if (!firstInvalidControl) {
        return true;
    }

    firstInvalidControl.reportValidity();

    return false;
};
